var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("g", [
    _c("defs", [
      _c("path", {
        attrs: {
          id: "checkmark@1x-a",
          d:
            "M18.71,7.21 C18.5222334,7.02068735 18.2666375,6.91420168 18,6.91420168 C17.7333625,6.91420168 17.4777666,7.02068735 17.29,7.21 L9.84,14.67 L6.71,11.53 C6.44740979,11.2763414 6.06944119,11.1820414 5.71847132,11.282622 C5.36750145,11.3832025 5.09685098,11.6633829 5.00847132,12.017622 C4.92009166,12.371861 5.02740979,12.7463414 5.29,13 L9.13,16.84 C9.3177666,17.0293127 9.57336246,17.1357983 9.84,17.1357983 C10.1066375,17.1357983 10.3622334,17.0293127 10.55,16.84 L18.71,8.68 C18.9152112,8.49068442 19.0319329,8.22419889 19.0319329,7.945 C19.0319329,7.66580111 18.9152112,7.39931558 18.71,7.21 Z"
        }
      })
    ]),
    _vm._v(" "),
    _c("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [
      _c("rect", {
        staticStyle: { "mix-blend-mode": "color-burn" },
        attrs: {
          width: "24",
          height: "24",
          fill: "#E3E3E3",
          "fill-opacity": ".01"
        }
      }),
      _vm._v(" "),
      _c("use", {
        attrs: {
          fill: _vm.currentColor,
          opacity: _vm.opacity,
          "fill-rule": "nonzero",
          "xlink:href": "#checkmark@1x-a"
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }